export function curry(f, ...argu) {
  return function (..._argu) {
    return f.apply(this, argu.concat(_argu));
  };
}

export function slice(a, start) {
  return Array.prototype.slice.call(a, start || 0);
}

function isType(type, target) {
  return Object.prototype.toString.call(target) === `[object ${type}]`;
}

export const type = {
  isString: curry(isType, 'String'),
  isArray: curry(isType, 'Array'),
};

export function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onerror = reject;
    script.onload = resolve;
    document.body.appendChild(script);
  });
}

export function parseVersion(version) {
  if (!type.isString(version)) return [];
  return version.split('.').map((v) => {
    v = parseInt(v, 10);
    return Math.max(isNaN(v) ? 0 : v, 0);
  });
}

// 判断appV版本小于tarV为true
export function lt(appV, tarV) {
  appV = parseVersion(appV);
  tarV = parseVersion(tarV);

  const aLen = appV.length;
  const tLen = tarV.length;

  for (let i = 0; i < Math.min(aLen, tLen); i++) {
    if (appV[i] !== tarV[i]) {
      return appV[i] < tarV[i];
    }
  }
  if (aLen < tLen) return true;
  return tarV.slice(aLen).filter((v) => v != 0).length > 0;
}

export function addParam(url, key, value) {
  return `${url}${/\?/.test(url) ? '&' : '?'}${key}=${value}`;
}

export function getScreen() {
  const ratio = window.devicePixelRatio || 1;
  return {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio,
  };
}

export function reportMetric(name, value, tags = {}) {
  const Owl = window.Owl;
  if (!Owl) {
    return;
  }
  const metricManager = Owl.MetricManager();
  metricManager.setTags(tags);
  metricManager.setMetric(name, value);
  metricManager.report();
}
